<template>
  <div class="dashboard p-4 pt-1">
    <!-- end nav -->
    <div class="mt-1 w-full">
      <div class="flex justify-between mb-3">
        <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
          Group Detail
        </h1>
        <router-link to="/group"
            class="inline-flex items-center border border-indigo-300 px-2 py-1 rounded-md text-indigo-500 hover:bg-indigo-50">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16l-4-4m0 0l4-4m-4 4h18">
                </path>
            </svg>
            <span class="ml-1 font-bold text-lg">Back</span>
        </router-link>
      </div>
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <h2 class=" text-gray-900 dark:text-gray-200 mt-2">Name Group : {{ dataGroupDetail.name }}</h2>
          <h2 class=" text-gray-900 dark:text-gray-200 mt-1">Created Date : {{ formattedCreatedAt }}</h2>
          <h2 class=" text-gray-900 dark:text-gray-200 mt-1">Total Plant : {{  }}</h2>
        </div>
        <div class="" >
          <div class="flex gap-2.5">
            <router-link :to="'/group/'+ dataGroupDetail.id + '/config'" class="h-9">
              <div class="">
                <div style="height: 46px;width: 46px;" class="flex items-center justify-center hover:bg-orange-500 flex-1 h-full p-2 bg-yellow1 text-white shadow rounded-lg">
                  <div class="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                    </svg>
                  </div>
                </div>
              </div>
            </router-link>
            <Modal
              title="Add plant in group"
              btnTextSubmit="Update"
              btnText="Add new plant"
              width="max-w-full"
              @submit="createMember(addMemberData,dataGroupDetail.id, selectId)"
              @click="resetAddMenber()"
            >
              <template v-slot:body>
                <div class="flex justify-end mb-3" >
                  <div class="flex items-center max-w-sm mx-auto">   
                      <label for="simple-search" class="sr-only">Search</label>
                      <div class="relative w-full">
                          <input v-model="search" type="text" id="simple-search" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search varietas..."/>
                      </div>
                      <button v-on:click.prevent="getMemberHandler" class="p-2.5 ms-2 text-sm font-medium text-white bg-blue-700 rounded-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                          <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
                          </svg>
                          <span class="sr-only">Search</span>
                      </button>
                  </div>
                  <label class="inline-flex cursor-pointer">
                    <input type="checkbox" v-model="isChecked" class="sr-only peer">
                    <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                    <span class="ms-3 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Show All</span>
                  </label> 
                </div>
                <div class="wrapping-table overflow-x-auto max-w-full" style="height: 400px; overflow-y: auto;">
                  <table
                    class="w-full text-sm text-left text-gray-500 dark:text-gray-400 lg:overflow-auto overflow-x-scroll"
                  >
                    <thead
                      class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
                    >
                      <tr>
                        <th
                          scope="col"
                          class="uppercase px-1 py-3"
                        >
                          No
                        </th>
                        <th
                          scope="col"
                          class="uppercase px-1 py-3"
                        >
                          Varietas
                        </th>
                        <th
                          scope="col"
                          class="uppercase px-1 py-3"
                        >
                          Sensor
                        </th>
                        <th
                          scope="col"
                          class="uppercase px-1 py-3"
                        >
                          Taraf Cekaman
                        </th>
                        <th
                          scope="col"
                          class="uppercase px-1 py-3"
                        >
                          Ulangan
                        </th>
                        <th
                          scope="col"
                          class="uppercase px-1 py-3"
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 odd:bg-white even:bg-gray-50"
                        v-for="(items, i ) in dataMemberException"
                        :key="items.id"
                      >
                        <td class="px-1 py-1">
                          {{ i+1 }}
                        </td>
                        <td class="py-1 px-1">
                          {{ items.varietas }}
                        </td>
                        <td class="py-1 px-1">
                          {{ items.sensorIndex }}
                        </td>
                        <td class="py-1 px-1">
                          {{ items.taraf }}
                        </td>
                        <td class="py-1 px-1">
                          {{ items.ulangan }}
                        </td>
                        <td class="py-1 px-1">
                          <div class="flex items-center mb-4">
                            <input 
                              v-model="addMemberData"
                              type="checkbox" 
                              :value="items.id" 
                              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                            </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </Modal>
          </div>
          <Dropdown placement="" class="mt-3">
            <template v-slot:button>
              <button class="flex px-7 py-3 w-full rounded-md bg-primary text-white">
                Classification
                <span class="ml-5 mt-1"
                  ><Icon icon="ant-design:caret-down-filled"
                /></span>
              </button>
            </template>
            <template v-slot:content>
              <div class="text-wrap">
                <a
                  v-on:click="select = 'All',selectId=0,getMemberGroup(dataGroupDetail?.id)"
                  class="block hover:bg-primary hover:text-white px-4 py-2"
                  >All</a
                >
                <a v-for="(item, index) in dataGroupDetail?.Classifications" :key="index"
                  v-on:click="select = item.name,selectId=item.id,getMemberGroup(dataGroupDetail?.id,item.id)"
                  class="block mt-4 hover:bg-primary hover:text-white px-4 py-2"
                  >{{ item.name }}</a
                >
              </div>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>
    <Modal
      v-if="select != 'All'"
      :title="'Add plant in '+ select"
      btnTextSubmit="Update"
      btnText="Add in class"
      width="max-w-full"
      :btn-show="false"
      :isOpenEx="openModal"
      @submit="createMemberClass(addMemberData,dataGroupDetail?.id ,selectId),openModal=false"
    >
      <template v-slot:body>
        <div class="wrapping-table overflow-x-auto mt-8">
        <table
          class="w-full text-sm text-left text-gray-500 dark:text-gray-400 lg:overflow-auto overflow-x-scroll"
        >
          <thead
            class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
          >
            <tr>
              <th
                scope="col"
                class="uppercase px-1 py-3"
              >
                No
              </th>
              <th
                scope="col"
                class="uppercase py-3"
              >
                Varietas
              </th>
              <th
                scope="col"
                class="uppercase py-3"
              >
                Taraf Cekaman
              </th>
              <th
                scope="col"
                class="uppercase py-3"
              >
                Ulangan
              </th>
              <th
                scope="col"
                class="uppercase py-3"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 odd:bg-white even:bg-gray-50"
              v-for="(items, i ) in dataMemberExcepClass"
              :key="items.id"
            >
              <td class="px-1 py-1">
                {{ i+1 }}
              </td>
              <td class="py-1">
                {{ items.varietas }}
              </td>
              <td class="py-1">
                {{ items.taraf }}
              </td>
              <td class="py-1">
                {{ items.ulangan }}
              </td>
              <td class="py-1">
                <div class="flex items-center mb-4">
                  <input 
                    v-model="addMemberData"
                    type="checkbox" 
                    :value="items?.PlantMembers[0]?.idPlantMember" 
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                  <label for="default-checkbox" class="ml-2 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Add plant</label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      </template>
    </Modal>
    <TableTanstack @dataPlant="handlerDeleteMember" :selectClass="select" :show-add-icon="true" @handlerAddClass="resetAddMenber('yes')" />
  </div>
</template>

<script>
  import { useCounterStore } from "@/store/counter";
  import { Icon } from "@iconify/vue";
  import { mapActions, mapState } from "pinia";
  import Modal from "@/components/modal.vue";
  import Dropdown from "@/components/Dropdown.vue";
  import TableTanstack from "./TableTanstack.vue";

  export default {
    name: "Dashboard",
    data() {
      return {
        addMemberData: [],
        select: 'All',
        selectId: 0,
        isChecked: false,
        search: '',
        openModal: false,
        dataDel: []
      };
    },
    components: {
      Icon, Modal, Dropdown, TableTanstack
    },
    methods: {
      ...mapActions(useCounterStore,[ 'getDataMemeberException','delMemberGroup' ,'createMember', 'delMember','getDetailGroup','getRealtimeSensor','getMemberGroup', 'createMemberClass']),
      handlerDeleteMember(value){
        this.delMemberGroup(this.$route.params.id,value,this.selectId)
      },
      handleCheckboxChange(){
        this.isChecked = !this.isChecked
      },
      resetAddMenber(clas){
        this.addMemberData = []
        if(clas != 'yes'){
          this.getDataMemeberException(this.$route.params.id,null,this.isChecked)
        }else{
          this.openModal=true
          this.getDataMemeberException(this.$route.params.id,this.selectId,false)
        }
      },
      getMemberHandler(){
        this.getDataMemeberException(this.$route.params.id,null,this.isChecked,this.search)
      },
      handlerMemberGet(clas){
       this.getMemberGroup(this.$route.params.id,clas)
      }
    },
    computed: {
      ...mapState(useCounterStore,[ 'dataMemberExcepClass','dataMemberException','dataGroupDetail','dataAllPlants','dataRealtime']),
      formattedCreatedAt() {
        if (this.dataGroupDetail && this.dataGroupDetail.createdAt) {
          const date = new Date(this.dataGroupDetail.createdAt);
          return date.toLocaleDateString("id-ID");
        }
        return "";
      },
    },
    created(){
      this.getDetailGroup(this.$route.params.id)
      this.getMemberGroup(this.$route.params.id)
      this.getRealtimeSensor()
    },
    watch: {
      addMemberData(newVal) {
        if (newVal) {
           console.log(this.addMemberData)
        }
      },
      isChecked(newVal){
        this.getMemberHandler()
      }
    },
  };
</script>
